<app-dialog-header
	[title]="'dialog.email.title'"
	variant="info"
	(closeClick)="close()"
/>
<mat-dialog-content style="text-align: left">
	<dl>
		<dt class="d-inline">{{ "dialog.email.to" | translate }}:</dt>
		<dd class="d-inline">{{ data.recipients }}</dd>
		<br />
		<dt class="d-inline">{{ "dialog.email.cc" | translate }}:</dt>
		<dd class="d-inline">{{ data.ccRecipients }}</dd>
		<br />
		<dt class="d-inline">{{ "dialog.email.subject" | translate }}:</dt>
		<dd class="d-inline">{{ data.subject }}</dd>
	</dl>
	<div
		class="border-top-gray pt-3"
		[innerHTML]="data.email | safeHtml"
	></div>
</mat-dialog-content>